module.exports = __webpack_public_path__ + "media/img/careers/why-work/why-work-img6-002ba6d6a2c7d073f0b3873b9f9f6f05.svg";